module.exports = __webpack_public_path__ + "static/media/tekura8.1083a1fb.jpg";